import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export const APP_SETTINGS_URL = 'assets/cfg/cfg.json';

//Important: Add the interfaces and properties for new configurations
//from \src\assets\cfg\cfg.json file

//Authentication settings for IDM connectivity
export interface IIdmAuthenticationSettings {
  issuer: string;
  clientId: string;
  scope: string;
  idmAuthPortalUrl: string;
}

//Session inactivity timeout
export interface IInactivityTimeout {
  sessionIdleTimeoutInMinutes: number
  idleWarningCounterInMinutes: number
}
//Environment settings
export interface IEnvironmentSettings {
  apiUrl: string; //Web API URL
  authentication: IIdmAuthenticationSettings;
  inactivityTimeout: IInactivityTimeout;
  tokenBase64Key: string;
}

@Injectable()
export class AppSettingsService {
  environmentSettings: IEnvironmentSettings;
  //Web API URL suffix
  static readonly API_URL: string = "api/"

  constructor(private https: HttpClient) {
  }

  //Important: Add the getters that you need in this region
  //If you modify the \src\assets\cfg\cfg.json file
  //#region getAppSettings

  //Important: the apiURL must be changed in \src\assets\cfg\cfg.json file
  //depending of the environment for manual deployment
  get apiUrl() {
    return this.environmentSettings.apiUrl + AppSettingsService.API_URL;
  }

  get clientId() {
    return this.environmentSettings.authentication.clientId;
  }

  get idmAuthPortalUrl() {
    return this.environmentSettings.authentication.idmAuthPortalUrl;
  }

 get sessionIdleTimeout() {
    return this.environmentSettings.inactivityTimeout.sessionIdleTimeoutInMinutes;
  }

  get idleWarningCounter() {
    return this.environmentSettings.inactivityTimeout.idleWarningCounterInMinutes;
  }
  get getTokenBase64Key() {
    return this.environmentSettings.tokenBase64Key;
  }
  loadAppSettings() {
    this.getEnvironmentVariablesToPromise().
      then((env: IEnvironmentSettings) => { this.environmentSettings = env });
  }

  getEnvironmentVariablesToPromise(): Promise<IEnvironmentSettings> {
    return this.https.get<IEnvironmentSettings>(APP_SETTINGS_URL).toPromise();
  }

}

